<vw-page [alwaysFillNav]="true" [page]="null" [showDealerInformation]="true">
  <vw-page-header>
    <div breadcrumbs>
      <vw-breadcrumbs
        [currentPage]="'cookieInfoPage.title' | translate"
      ></vw-breadcrumbs>
    </div>
  </vw-page-header>
  <div class="cookie-info-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center">{{ "cookieInfoPage.title" | translate }}</h1>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h4
            class="py-3 semibold"
            [innerHTML]="
              'cookieInfoPage.section.what.title' | translate | safe: 'html'
            "
          ></h4>
          <div
            class="content"
            [innerHTML]="
              'cookieInfoPage.section.what.body' | translate | safe: 'html'
            "
          ></div>
        </div>
        <div class="col-12 col-lg-6">
          <h4
            class="py-3 semibold"
            [innerHTML]="
              'cookieInfoPage.section.required.title' | translate | safe: 'html'
            "
          ></h4>
          <div
            class="content"
            [innerHTML]="
              'cookieInfoPage.section.required.body' | translate | safe: 'html'
            "
          ></div>
          <a
            [routerLink]="'.'"
            [queryParamsHandling]="'preserve'"
            [fragment]="'TABLE_REQUIRED'"
            >{{ "cookieInfoPage.tableLink" | translate }}</a
          >
        </div>
        <div class="col-12 col-lg-6">
          <h4
            class="py-3 semibold"
            [innerHTML]="
              'cookieInfoPage.section.functional.title'
                | translate
                | safe: 'html'
            "
          ></h4>
          <div
            class="content"
            [innerHTML]="
              'cookieInfoPage.section.functional.body'
                | translate
                | safe: 'html'
            "
          ></div>
          <a
            [routerLink]="'.'"
            [queryParamsHandling]="'preserve'"
            [fragment]="'TABLE_FUNCTIONAL'"
            >{{ "cookieInfoPage.tableLink" | translate }}</a
          >
        </div>
        <div class="col-12 col-lg-6">
          <h4
            class="py-3 semibold"
            [innerHTML]="
              'cookieInfoPage.section.performance.title'
                | translate
                | safe: 'html'
            "
          ></h4>
          <div
            class="content"
            [innerHTML]="
              'cookieInfoPage.section.performance.body'
                | translate
                | safe: 'html'
            "
          ></div>
          <a
            [routerLink]="'.'"
            [queryParamsHandling]="'preserve'"
            [fragment]="'TABLE_PERFORMANCE'"
            >{{ "cookieInfoPage.tableLink" | translate }}</a
          >
        </div>
        <div class="col-12 col-lg-6">
          <h4
            class="py-3 semibold"
            [innerHTML]="
              'cookieInfoPage.section.marketing.title'
                | translate
                | safe: 'html'
            "
          ></h4>
          <div
            class="content"
            [innerHTML]="
              'cookieInfoPage.section.marketing.body' | translate | safe: 'html'
            "
          ></div>
          <a
            [routerLink]="'.'"
            [queryParamsHandling]="'preserve'"
            [fragment]="'TABLE_MARKETING'"
            >{{ "cookieInfoPage.tableLink" | translate }}</a
          >
        </div>
      </div>
      <div class="row">
        <table class="mb-4">
          <tbody
            [vwTargetable]
            [id]="section.type"
            *ngFor="let section of cookieSections"
          >
            <tr>
              <th colspan="3">
                <h4 class="py-3">
                  {{
                    "cookieInfoPage.table.titles." + section.type | translate
                  }}
                </h4>
              </th>
            </tr>
            <ng-template
              [ngIf]="section.cookies.length > 0"
              [ngIfElse]="cookieTableEmpty"
            >
              <tr>
                <th class="pe-2">
                  {{
                    "cookieInfoPage.table.column-titles.provider" | translate
                  }}
                </th>
                <th class="px-2">
                  {{
                    "cookieInfoPage.table.column-titles.cookie-name" | translate
                  }}
                </th>
                <th class="pl-2">
                  {{
                    "cookieInfoPage.table.column-titles.duration" | translate
                  }}
                </th>
              </tr>
              <tr *ngFor="let cookie of section.cookies">
                <td class="pe-2">{{ cookie.service }}</td>
                <td class="px-2">{{ cookie.name }}</td>
                <td class="pl-2">
                  {{
                    cookie.duration[0]
                      | translate
                        : (cookie.duration[1] != null
                            ? { count: cookie.duration[1] }
                            : null)
                  }}
                </td>
              </tr>
            </ng-template>
            <ng-template #cookieTableEmpty>
              <tr>
                <td colspan="3">
                  <em>
                    {{ "cookieInfoPage.table.empty" | translate }}
                  </em>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</vw-page>
